<template>
    <div class="m--t-1">
        <template v-for="columnDefinition in columnDefinitions">
            <form-checkbox
                :value="isSelected(columnDefinition.id)"
                @change="select(columnDefinition)"
                :name="'catalogue-columns-' + columnDefinition.id"
                class="checkbox--third">
                {{ messages[columnDefinition.type] }}
            </form-checkbox>
        </template>
    </div>
</template>

<script>
import FormCheckbox from 'domovio-core/src/components/Form/Input/FormCheckbox';
import {messages} from '@/modules/ProjectModule/modules/ExtensionModule/messages/catalogue';

export default {
    name:       'CatalogueColumnOffer',
    components: {FormCheckbox},
    computed:   {
        columnDefinitions() {
            return this.$store.getters['projects/project/extension/catalogue/columnDefinitions'];
        },
        isProjectColumnActive() {
            return this.$store.getters['projects/project/extension/catalogue/isProjectColumnActive']
        }
    },
    data() {
        return {
            messages
        }
    },
    methods:    {
        isSelected(definitionId) {
            return this.$store.getters['projects/project/extension/catalogue/isProjectColumnActive'](definitionId);
        },
        select(definition) {
            this.$store.dispatch('projects/project/extension/catalogue/selectProjectColumnDefinition', definition)
        }
    }
}
</script>
